<section
  class="horizontal-carousel vertical-as"
  #carouselContainer
  [id]="customId"
  [style.--margin-left]="isDetailPageCards ? '7.5vw' : '7.36vw'"
>
  <div class="horizontal-carousel-header" *ngIf="showHeader">
    <h2 [style]="'fontSize.28' | translate">
      {{ localizedTitle }}
    </h2>
  </div>
  <ng-container *ngIf="!inAppBanner; else inAppBannerCard">
    <section
      id="horizontal-carousel-cards"
      class="horizontal-carousel-track horizontal-as focusable-container horizontal-focusable-container"
      [ngClass]="'horizontal-carousel-cards-' + index"
      *ngIf="carouselWidth > 0"
      (keydown.ArrowLeft)="onArrowLeft()"
      (keydown.ArrowRight)="onArrowRight()"
      #horizontalCarousel
    >
      <ng-container
        *ngFor="
          let item of horizontalList;
          let i = index;
          trackBy: trackByIndex
        "
      >
        <app-cards
          [resource]="item"
          [carouselWidth]="carouselWidth"
          [noOfCardsShown]="noOfCardsShown"
          [carouselGap]="carouselGap"
          [aspectRatio]="aspectRatio"
          [showPlayIcon]="showPlayIcon"
          [isContinueWatching]="containers.sourceType === 'continue_watching'"
          [isTitleVisible]="isTitleVisible"
          [isHalfVisible]="isHalfVisible"
          (click)="onClick(item)"
          [isSeries]="isSeries"
          [index]="i"
          [bookmark]="bookmark"
          [lang]="lang"
          [nowPlayingId]="nowPlayingId"
          [isPlayerPage]="!!playerContainerType"
          [isEpisodeList]="isEpisodeList"
          [verticalIndex]="index"
          [isDetailPageCards]="isDetailPageCards"
          [scrollMovement]="scrollMovement"
          (focusCard)="onFocusCard($event)"
          (focusOut)="onFocusOut()"
        >
        </app-cards>
      </ng-container>
    </section>
  </ng-container>
  <ng-template #inAppBannerCard>
    <app-in-app-banner
      [resource]="containers?.resources[0]"
      (keydown.ArrowLeft)="focusLeft.emit()"
      [verticalIndex]="index"
      [index]="0"
    ></app-in-app-banner>
  </ng-template>
</section>
